import React from "react";
import ReactDOM from "react-dom/client";
import AppRouter from "./App";
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "react-datepicker/dist/react-datepicker.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./assets/css/iconsax.css";
require("./assets/css/feather.css");

require(".//assets/icons/fontawesome/css/fontawesome.min.css");
require(".//assets/icons/fontawesome/css/all.min.css");
require(".//assets/icons/feather/css/iconfont.css");
require(".//assets/css/customstyleclient.css");

const root = ReactDOM.createRoot(document.getElementById("root")  as HTMLElement);
root.render(
    
    <AppRouter/>
  
);
